<template>
    <teleport to="body">
        <div class="modal-content">
            <h5 class="modal-title mb-3">Delete Contact</h5>
            <p>Are you sure you want to remove {{ contact.name }} from your contacts?</p>
            <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-outline-shareguard me-2" :disabled="isLoadingDeleteContact" @click="closeDeleteClicked">Cancel</button>
                <button class="btn btn-shareguard" :disabled="isLoadingDeleteContact" @click="deleteContactClick">
                    {{ isLoadingDeleteContact ? "Deleting..." : "Delete" }}
                </button>
            </div>
        </div>
    </teleport>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: 'DeleteContactModal',
    props: {
        contact: {
            type: Object,
            required: true
        }
    },
    emits: ['close-delete-contact-modal'],
    data() {
        return {
            name: this.contact.name,
            email: this.contact.email
        }
    },
    computed: {
        ...mapGetters("contacts", ["isLoadingDeleteContact"])
    },
    created() {
        this.$store.commit('setOverlay', true);
    },
    beforeUnmount() {
        this.$store.commit('setOverlay', false);
    },
    methods: {
        ...mapActions("contacts", ["deleteContactAction"]),
        async deleteContactClick() {
            try {
                await this.deleteContactAction({ name: this.name, email: this.email });
                this.closeDeleteClicked();
            } catch (error) {
                console.error("Error deleting contact:", error);
            }
        },
        closeDeleteClicked() {
            this.$emit('close-delete-contact-modal');
        }
    }
}
</script>

<style scoped>
.modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 2rem;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
    z-index: $zindex-modal-content;
}
</style>
